import { getDataMapper, mapField, mapMediaToServer } from "@/shared";

export const mapInventoryClientToServer = getDataMapper({
    title: mapField("title", String),
    description: mapField("description", String),
    category_resource_id: mapField("categoryResourceId", Number),
    media: mapField("media", mapMediaToServer),
});
